module.exports = __webpack_public_path__ + "static/media/aika-lesb.df0c330a.jpg";